import { createApp } from "vue";
import "element-plus/dist/index.css";
import "./style.css";
import App from "./App.vue";
import { loadingFadeOut } from "virtual:app-loading";
import { autoFillBottom } from "@/directives/autoFillBottom.ts";
import "vue-data-ui/style.css";

loadingFadeOut();

const app = createApp(App);

// router
import router from "./route.ts";
app.use(router);

// pinia（全局注册）
import pinia from "./store";
app.use(pinia);
app.directive("auto-fill-bottom", autoFillBottom);

app.mount("#app");
